module.exports = __webpack_public_path__ + "static/media/casters.c53b5546.svg";